<template>
  <Front />
</template>

<script>
import Front from '../components/Front';

export default {
  components: {
  Front,
  },
};
</script>
